import { Box, Drawer, IconButton, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import { ChevronLeft } from "@mui/icons-material";

const MobileDrawer = ({
  showDrawer,
  onClose,
  children,
  packageName,
}: {
  showDrawer: boolean;
  onClose: () => void;
  children: React.ReactNode;
  packageName: any;
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <Drawer
      open={showDrawer}
      onClose={onClose}
      PaperProps={{
        sx: { maxWidth: "100%" },
      }}
    >
      <Stack>
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          sx={{
            height: "70px",
            p: 2,
            "& .header-logo": {
              maxWidth: "258px",
              maxHeight: "60px",
            },
          }}
          gap={3}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <IconButton onClick={handleBack}>
              <ChevronLeft />
            </IconButton>
            <Typography fontSize={20} fontWeight={600} color="text.primary">
              {packageName || ""}
            </Typography>
          </Box>
          <IconButton aria-label="menu" size="large" onClick={onClose}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Stack>

        {children}
      </Stack>
    </Drawer>
  );
};
export default MobileDrawer;
